import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { ColumnDefinition } from 'components';
import { of } from 'rxjs';
import { catchError, map, take, filter } from 'rxjs/operators';
import { BaseReportGridSource } from '../base-report-grid-source';
import { ReportWrapperService } from '../../../../core/services/service-wrappers/report-wrapper.service';
import { DateDisplayPipe } from 'projects/components/src/lib/shared/pipes/date-display/date-display.pipe';
import { saveAs } from 'file-saver';
import { getSelectedDataSetId } from 'src/app/core/state/data-set/data-set.selectors';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class SelectedProceduresService extends BaseReportGridSource<any> {
  datasetId$ = this.baseStore.select(getSelectedDataSetId).pipe(filter((cId) => !!cId));
  datasetId;
  constructor(private reportService: ReportWrapperService, @Inject(LOCALE_ID) private locale: string, private baseStore: Store<any>) {
    super();
    this.datasetId$.subscribe((datasetIdFromStore) => {
      this.datasetId = datasetIdFromStore;
    });

  }
  datePipe: DateDisplayPipe = new DateDisplayPipe(this.locale);
  initialize(query: any, columnDefinitions: ColumnDefinition[]) {
    this.gridColumns = columnDefinitions;
    const request = {
      slug: 'selected-procedures',
      datasetId: this.datasetId,
      insuranceCarrierIds: query.insuranceCarrierIds?.join(',') ?? '',
      financialClassIds: query.financialClassIds?.join(',') ?? '',
      locationIds: query.locationIds?.join(',') ?? '',
      attendingProviderIds: query.attendingProviderIds?.join(',') ?? '',
      referringProviderIds: query.referringProviderIds?.join(',') ?? '',
      procedureCodeIds: query.procedureCodeIds?.join(',') ?? '',
      placeOfServiceCodeIds: query.placeOfServiceCodeIds?.join(',') ?? '',
      serviceDateRangeStart: this.datePipe.transform(query.serviceDateRangeStart),
      serviceDateRangeEnd: this.datePipe.transform(query.serviceDateRangeEnd),
      postDateRangeStart: this.datePipe.transform(query.postDateRangeStart),
      postDateRangeEnd: this.datePipe.transform(query.postDateRangeEnd),
      billedDateRangeStart: this.datePipe.transform(query.billedDateRangeStart),
      billedDateRangeEnd: this.datePipe.transform(query.billedDateRangeEnd),
      minBalance: query.minBalance,
      maxBalance: query.maxBalance,
      coverages: query.coverages,
      textParameters: this.textParameters
    };
    this.loadInitialData(
      this.reportService.apiV1ReportPost(request).pipe(
        map((x) => {
          this.textParameters['User'] = x.processedBy;
          this.datasetName = x.datasetName;
          this.reportExecutionId = x.reportExecutionId;
          this.resultColumns = x.columns;
          return x.data.map((data) => {
            return { ...data };
          });
        }),
        catchError(() => of([]))
      )
    );
  }
}
